var map = {
	"./N3Lexer": 119,
	"./N3Lexer.js": 119,
	"./N3Parser": 120,
	"./N3Parser.js": 120,
	"./N3Store": 221,
	"./N3Store.js": 221,
	"./N3StreamParser": 222,
	"./N3StreamParser.js": 222,
	"./N3StreamWriter": 223,
	"./N3StreamWriter.js": 223,
	"./N3Util": 121,
	"./N3Util.js": 121,
	"./N3Writer": 122,
	"./N3Writer.js": 122
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 495;